import pulse from '@finn-no/pulse-sdk';
import type { PrepackageSearchState } from '../../types';
import { buildPrepackageTrackingItem } from './buildPrepackageTrackingItem';

export const trackPrepackageSearchClick = (position: string, state: PrepackageSearchState): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Search',
        name: 'Search prepackage',
        object: {
            // @ts-ignore id can only be string
            id: undefined,
            type: 'UIElement',
            elementType: 'Button',
            position,
            numHits: state.totalOffers ?? 0,
            items: [buildPrepackageTrackingItem(state)],
        },
        target: {
            id: '/reise/pakkereiser',
            type: 'Listing',
        },
        vertical: {
            name: 'travel',
            subVertical: 'prepackage',
        },
    });
};
